import { create } from "zustand";

export enum FeatureFlag {
    CUTOVER_CHECKLIST = "cutover-checklist",
    AZURE_RECOMMENDATION = "azure-recommendation",
    AZURE_CONSUMPTION_PLANNER = "azure-consumption-planner",
    CMO_SUPPORT = "cmo-support",
    SOURCE_ASSESSMENT_REPORT = "source-assessment-report",
    DASHBOARD_V2 = "dashboard-v2",
    MIGRATION_READINESS = "migration-readiness",
    STORED_HOST_ACTIONS = "stored-host-actions",
}

export interface AppGlobalState {
    initialized: boolean;
    sideBarOpen: boolean;
    isLightMode: boolean;
    appSubmenu: string | null;
    setInitialized: (v: boolean) => void;
    setAppSubmenu: (s: string) => void;
    toggleSideBar: () => void;
    openSideBar: () => void;
    closeSideBar: () => void;
    toggleLightMode: () => void;
}

export type AppGlobalService = AppGlobalState;

export const useAppGlobalState = create<AppGlobalState>((set, get) => ({
    initialized: false,
    sideBarOpen: false,
    isLightMode: false,
    appSubmenu: null,
    setInitialized: (v) => set({ initialized: v }),
    setAppSubmenu: (s) => set({ appSubmenu: s }),
    toggleSideBar: () => set((state) => ({ sideBarOpen: !state.sideBarOpen })),
    openSideBar: () => set({ sideBarOpen: true }),
    closeSideBar: () => set({ sideBarOpen: false }),
    toggleLightMode: () => set((state) => ({ isLightMode: !state.isLightMode })),
}));

export const sleepMS = (duration = 0) => {
    return new Promise<void>((resolve) => {
        setTimeout(resolve, duration);
    });
};

export const isInternalUser = (): boolean => {
    //@ts-ignore
    return !!window.secret_support_mode;
};

export const isAcmeStoragePlugin = (): boolean => {
    //@ts-ignore
    return !!window._acme_storage_plugin;
};

export const isActivePage = (page: string): boolean => {
    return window.location.pathname === page;
};
